var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.03 96.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m47.65,0C21.33,0,0,21.33,0,47.65v48.38s48.38,0,48.38,0c26.31,0,47.65-21.33,47.65-47.65V0s-48.38,0-48.38,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--iconBgColor)",
    d: "m48,14.9h33.14v33c0,18.33-14.91,33.23-33.23,33.23H14.9v-33.14c0-18.25,14.85-33.1,33.1-33.1Zm-.1,53.49c11.3,0,20.49-9.19,20.49-20.49v-20.25s-20.39,0-20.39,0c-11.22,0-20.35,9.13-20.35,20.35v20.39s20.25,0,20.25,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.c6862cf27b5de8f1e1812c3539cfe610.svg";
export { ForwardRef as ReactComponent };